import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MovieCard from "@/components/MovieCard";

export default function Row({ title, items, onAdd }) {
  const ref = useRef(null);
  if (!items || items.length === 0) return null;

  const scroll = (dir) => {
    if (ref.current) {
      ref.current.scrollBy({ left: dir * ref.current.clientWidth * 0.8, behavior: "smooth" });
    }
  };

  return (
    <section data-testid={`row-${title.replace(/\s+/g, "-").toLowerCase()}`} className="relative group/row py-5">
      <div className="px-4 sm:px-10 lg:px-16 mb-4 flex items-end gap-3">
        <span className="h-5 w-px bg-gold" />
        <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">{title}</h2>
      </div>
      <div className="relative">
        <button
          onClick={() => scroll(-1)}
          className="hidden md:flex absolute left-0 top-0 bottom-0 z-20 w-12 items-center justify-center bg-gradient-to-r from-ink to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronLeft className="w-8 h-8 text-gold" strokeWidth={1.5} />
        </button>
        <div
          ref={ref}
          className="flex gap-4 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-4 sm:px-10 lg:px-16 scroll-smooth"
        >
          {items.map((item) => (
            <MovieCard key={item.id + (item.episode_id || "")} item={item} onAdd={onAdd} />
          ))}
        </div>
        <button
          onClick={() => scroll(1)}
          className="hidden md:flex absolute right-0 top-0 bottom-0 z-20 w-12 items-center justify-center bg-gradient-to-l from-ink to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronRight className="w-8 h-8 text-gold" strokeWidth={1.5} />
        </button>
      </div>
    </section>
  );
}
